module.exports = "/img/loading-gif-white.fcb30a00.gif";